import { IS_LOGGED_IN } from 'components/Authorization/AuthorizationHandler';

const isLoggedIn = () => localStorage.getItem(IS_LOGGED_IN) === 'true';

export default isLoggedIn;
